import React from 'react';
import { getText } from 'src/utils/i18n';

export default class NoSkuQuantity extends React.PureComponent {
  render() {
    const { i18n, minOrder, unitEven } = this.props;
    return (
      <dl
        className="product-quantity util-clearfix"
        style={{
          overflow: 'hidden',
        }}
      >
        <dt className="name">
          {getText(i18n, 'marketAction_quantity_name', 'Quantity:')}
        </dt>
        <dd
          className="value"
          style={{
            padding: 0,
          }}
        >
          <div
            data-role="quantity-widget"
            className="quantity-value"
            style={{
              float: 'none',
            }}
          >
            <a
              className="btn-quantity quantity-down"
              data-role="quantity-down"
              data-spm-anchor-id="0.0.0.0"
            >
              <b>-</b>
            </a>
            <input
              type="text"
              defaultValue={minOrder}
              maxLength="6"
              className="ui2-textfield ui2-textfield-single"
              data-role="wholesale-order-quantity"
            />
            <a className="btn-quantity quantity-up" data-role="quantity-up">
              <b>+</b>
            </a>
            <span className="product-unit-bar">
              <span className="product-unit" title={unitEven}>
                {unitEven}
              </span>
              <span
                data-role="product-inventory"
                className="stock-partition product-inventory inventory-hide"
              >
                <span data-role="inventory-count" />{' '}
                {getText(i18n, 'marketAction_quantity_available', 'available')}
              </span>
            </span>
          </div>
        </dd>
      </dl>
    );
  }
}
